import {default as createAdultModal} from '../legacy/age-confirmation';

export default function initAdultModal(selector) {
    const element = document.querySelector(selector);

    if (!element) return;

    createAdultModal(element);
}
